import React, { useState, useRef } from "react";
import Box from "@material-ui/core/Box";
import useStyles from "./style";
import {
  Divider,
  Grid,
  Paper,
  Typography,
  Button,
  InputBase,
  Tooltip,
  IconButton,
} from "@material-ui/core";
import BasicModal from "../../../../common/summaryMentorModal/Modal";
import { withRouter } from "react-router-dom";
import hashImage from "../../../../../assets/images/hashImage.jpeg";
import iconTooltip from "../../../../../assets/svg/dashboard/iconTooltip.svg";
import {
  getStepperTooltipData,
  openLoader,
  closeLoader,
} from "../../AdminDashboard/AdminMentorAction/dependencies/action";
import AnimeList from "../../StartupDashboard/ViewAllMentorList/AnimeList";
import "../MentorFeedback/style.scss";
import "../../MentorDashboard/AllStartUpList/styles.scss";
// import  ScheduleSession from '../../../../../assets/svg/dashboard/Button Schedule Session.svg'
// import  SendMessage from '../../../../../assets/svg/dashboard/Button Send Message.svg'
import EngagementNotesDataModal from "../../../../common/engagementNotesDataModal";
import requestMentor from "../../../../../assets/images/request-mentor.png";
import cohortImg from "../../../../../assets/images/cohort-program.png";
import linewitdot from "../../../../../assets/svg/dashboard/Line wit Dot.svg";
import blueButton from "../../../../../assets/svg/dashboard/blue_button.svg";
import sideGraphic from "../../../../../assets/svg/dashboard/engagementSummaryMentorshipOverviewSessionPlan.svg";
import MentorshipDocumentTable from "./MentorshipDocumentTable";
import CompletedSessionTable from "./CompletedSessionTable";
import cohortIcon from "../../../../../assets/svg/cohortMeetingCircle.svg";
import Stepper from "./Stepper";
import Modal from "./Modal/modal";
import ModalDocUpload from "../../../../common/modalDocUpload";
import SessionsModal from "../../../../common/sessionsModal";
import SummaryModal from "../../../../common/summaryModal";
import SessionsMomModal from "../../../../common/sessionsMomModal";
import MentorFeedBackModal from "../../../../common/mentorFeedBackModal";
import EngagementNotesModal from "../../../../common/engagementNotesModal";
import AllSummaryModal from "../../../../common/allSummaryModal";
import { useEffect } from "react";
import {
  MENTORSHIP_ENGAGEMENT_SUMMARY,
  MENTORSHIP_SESSIONS_LIST,
  MENTORSHIP_SESSION_PLAN_CONFIRM,
  MENTORSHIP_SESSION_UPDATE,
  GET_SUMMARY_DATA,
} from "../../../../common/constants/ApplicationUrl";
import { useParams } from "react-router-dom";
import { connect } from "react-redux";
import axios from "axios";
import { isLoading } from "../../../../common/constants/actionConstants";
import api from "../../../../common/dependencies/utils/Api";

import clsx from "clsx";
import MailIcon from "@material-ui/icons/Mail";
import ChatBubbleIcon from "@mui/icons-material/MessageRounded";
import ChatBoxModal from "../../../../common/chatBoxModal";
import ReactSelect from "react-select";
import moment from "moment";
import swal from "sweetalert";
import { useHistory } from "react-router-dom";
import {
  getSessionSummaryData,
  postSessionSummaryData,
  getUploadDocumentList,
  getStartUpFeedback,
  getEngagementNotes,
  postStartUpFeedback,
} from "../dependencies/action";
import { toast } from "react-toastify";
import * as CryptoJS from "crypto-js";
import { PROFILE_KEY } from "../../../../common/constants/actionConstants";
const customStyles = {
  control: (styles) => ({
    ...styles,
    backgroundColor: "white",
    maxHeight: "41.5px",
    color: "#333",
  }),
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      backgroundColor: isSelected ? "#b499c7" : isFocused ? "#e4d7ee" : "white",
      color: isSelected ? "white" : "black",
      cursor: isDisabled ? "not-allowed" : "default",
    };
  },
};
const DisplaySurface = (props) => {
  const classes = useStyles();

  return (
    <Box sx={{ position: "relative", width: "100%" }}>
      <Box className={classes.lineWithDotContainer}>
        <img
          src={linewitdot}
          alt="line with dot"
          className={classes.lineWithDotRight}
        />
        <img
          src={linewitdot}
          alt="line with dot"
          className={classes.lineWithDotLeft}
          style={{ transform: "rotate(180deg)" }}
        />
      </Box>
      <Box className={classes.displaySurfaceContentBox}>{props.content}</Box>
    </Box>
  );
};

const UpperDisplaySurface = (props) => {
  const classes = useStyles();
  const params = useParams();

  return (
    <Box style={{ width: "100%", display: "flex", justifyContent: "center" }}>
      <Paper elevation={3} className={classes.upperDisplay}>
        <Grid container>
          <Grid item xs={12} md={2} className={classes.upperDisplayImage}>
            <img
              style={{ height: "100px" }}
              src={requestMentor}
              alt="peopleweblogo"
            />
          </Grid>
          <Grid item container spacing={1} xs={12} md={10}>
            <Grid
              item
              xs={12}
              md={4}
              className={classes.mobileMarginForUpperDisplayGrids}
            >
              <Typography
                // className={[classes.headingthreeone,"headingthrough"]}
                className={clsx(
                  classes.headingthreeone,
                  "homepageThirdDescription",
                  "headingthrough"
                )}
                style={{ whiteSpace: "nowrap" }}
              >
                MENTORSHIP ID
              </Typography>
              <Box className={classes.showInMiddle}>
                <DisplaySurface
                  content={`M${params?.mentorshipId?.substr(
                    params.mentorshipId.length - 6
                  )}`}
                />
              </Box>
            </Grid>
            <Grid
              item
              xs={12}
              md={2}
              className={classes.mobileMarginForUpperDisplayGrids}
            >
              <Typography
                className={clsx(
                  classes.headingthreeone,
                  "homepageThirdDescription"
                )}
              >
                INDUSTRY
              </Typography>
              <Box className={classes.showInMiddle}>
                <Typography
                  className={clsx(
                    classes.headingthreetwo,
                    "homepageThirdDescription"
                  )}
                >
                  {props.data?.industry}
                </Typography>
              </Box>
            </Grid>
            <Grid
              item
              xs={12}
              md={2}
              className={classes.mobileMarginForUpperDisplayGrids}
            >
              <Typography
                className={clsx(
                  classes.headingthreeone,
                  "homepageThirdDescription"
                )}
              >
                FUNCTION
              </Typography>
              <Box className={classes.showInMiddle}>
                <Typography
                  className={clsx(
                    classes.headingthreetwo,
                    "homepageThirdDescription"
                  )}
                >
                  {props.data?.function}
                </Typography>
              </Box>
            </Grid>
            <Grid
              item
              xs={12}
              md={2}
              className={classes.mobileMarginForUpperDisplayGrids}
            >
              <Typography
                className={clsx(
                  classes.headingthreeone,
                  "homepageThirdDescription"
                )}
              >
                STAGE
              </Typography>
              <Box className={classes.showInMiddle}>
                <Typography
                  className={clsx(
                    classes.headingthreetwo,
                    "homepageThirdDescription"
                  )}
                >
                  {props.data?.stage}
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} md={2}>
              <Typography
                className={clsx(
                  classes.headingthreeone,
                  "homepageThirdDescription"
                )}
              >
                KEYWORDS
              </Typography>
              <Box className={classes.showInMiddle}>
                <Typography
                  className={clsx(
                    clsx(classes.headingthreetwo, "homepageThirdDescription"),
                    classes.cursorPointer
                  )}
                  style={{ fontSize: "12px", textAlign: "left" }}
                >
                  <Tooltip
                    classes={{
                      tooltip: classes.tooltip,
                      tooltipArrow: classes.tooltipArrow,
                    }}
                    title={
                      <div style={{ padding: "15px" }}>
                        {props.data?.keys?.sub_function &&
                          props.data?.keys?.sub_industry &&
                          [
                            ...props.data?.keys?.sub_function,
                            ...props.data?.keys?.sub_industry,
                          ].map((ele, index) => (
                            <Typography
                              style={{
                                fontFamily: "Montserrat",
                                fontSize: "14px",
                                color: "#fff",
                              }}
                            >
                              {index + 1}. {ele}
                            </Typography>
                          ))}
                      </div>
                    }
                    placement="left"
                    arrow
                  >
                    <div>
                      {props.data?.keys?.sub_function &&
                        props.data?.keys?.sub_industry &&
                        [
                          ...props.data?.keys?.sub_function,
                          ...props.data?.keys?.sub_industry,
                        ].map((ele, index) => {
                          return (
                            index < 4 && (
                              <>
                                {index + 1}. {ele}
                                <br />
                              </>
                            )
                          );
                        })}
                      {props.data?.keys?.sub_function &&
                        props.data?.keys?.sub_industry &&
                        [
                          ...props.data?.keys?.sub_function,
                          ...props.data?.keys?.sub_industry,
                        ].length > 4 &&
                        "..."}
                    </div>
                  </Tooltip>
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Paper>
    </Box>
  );
};
const UpperDisplaySurface2 = (props) => {
  const classes = useStyles();
  const params = useParams();

  return (
    <Box style={{ width: "100%", display: "flex", justifyContent: "center" }}>
      <Paper
        elevation={3}
        className={classes.upperDisplay}
        style={{ position: "relative" }}
      >
        {/* <Typography
          style={{
            fontFamily: "Montserrat",
            fontSize: "20px",
            fontWeight: "bold",
            color: "#6f59a6",
            marginBottom: "25px",
          }}
        >
          Cohort Details
        </Typography> */}
        <Tooltip
          classes={{
            tooltip: classes.tooltip,
            tooltipArrow: classes.tooltipArrow,
          }}
          PopperProps={{
            disablePortal: true,
          }}
          placement="left"
          arrow
          title={
            <Typography
              style={{
                fontFamily: "Montserrat",
                fontSize: "14px",
                color: "#fff",
                fontWeight: "bold",
                padding: 0,
                margin: 0,
              }}
            >
              View Cohort Details
            </Typography>
          }
        >
          <img
            src={cohortIcon}
            style={{
              position: "absolute",
              right: 20,
              bottom: 20,
              height: "40px",
              width: "40px",
              cursor: "pointer",
            }}
            onClick={() => {
              window.open(
                `/cohort-programs/all/${props.data?.cohortApplicationId}`,
                "_blank"
              );
            }}
          />
        </Tooltip>
        <Grid container justifyContent="center">
          <Grid item xs={12} md={2} className={classes.upperDisplayImage}>
            <img
              style={{ height: "100px" }}
              src={cohortImg}
              alt="peopleweblogo"
            />
          </Grid>
          <Grid item container spacing={1} xs={12} md={10}>
            <Grid
              item
              xs={12}
              md={4}
              className={classes.mobileMarginForUpperDisplayGrids}
            >
              <Typography
                // className={[classes.headingthreeone,"headingthrough"]}
                className={clsx(
                  classes.headingthreeone,
                  "homepageThirdDescription idofCohortpadding"
                )}
                style={{ whiteSpace: "nowrap" }}
              >
                COHORT ID
              </Typography>
              <Box className={classes.showInMiddle}>
                <DisplaySurface
                  content={`C${props?.data?.cohortId?.substr(
                    props?.data?.cohortId?.length - 6
                  )}`}
                />
              </Box>
            </Grid>
            <Grid
              item
              xs={12}
              md={2}
              className={classes.mobileMarginForUpperDisplayGrids}
            >
              <Typography
                className={clsx(
                  classes.headingthreeone,
                  "homepageThirdDescription"
                )}
              >
                COHORT NAME
              </Typography>
              <Box className={classes.showInMiddle}>
                <Typography
                  className={clsx(
                    classes.headingthreetwo,
                    "homepageThirdDescription"
                  )}
                >
                  {props.data?.cohortName}
                </Typography>
              </Box>
            </Grid>
            <Grid
              item
              xs={12}
              md={2}
              className={classes.mobileMarginForUpperDisplayGrids}
            >
              <Typography
                className={clsx(
                  classes.headingthreeone,
                  "homepageThirdDescription"
                )}
              >
                ORGANIZATION
              </Typography>
              <Box className={classes.showInMiddle}>
                <Typography
                  className={clsx(
                    classes.headingthreetwo,
                    "homepageThirdDescription"
                  )}
                >
                  {props.data?.organization_name}
                </Typography>
              </Box>
            </Grid>
            <Grid
              item
              xs={12}
              md={2}
              className={classes.mobileMarginForUpperDisplayGrids}
            >
              <Typography
                className={clsx(
                  classes.headingthreeone,
                  "homepageThirdDescription"
                )}
              >
                CREATED BY
              </Typography>
              <Box className={classes.showInMiddle}>
                <Typography
                  className={clsx(
                    classes.headingthreetwo,
                    "homepageThirdDescription"
                  )}
                >
                  {props.data?.cohortAdmin}
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Paper>
    </Box>
  );
};

const SecondaryDisplaySurface = (props) => {
  const classes = useStyles();

  return (
    <Paper elevation={3} className={classes.secondaryDisplay}>
      {props.children}
    </Paper>
  );
};

const FirstDisplaySurface = (props) => {
  const classes = useStyles();
  const history = useHistory();
  const params = useParams();

  const currentRoute = window.location.href;
  let sample;
  sample = currentRoute.slice(0, currentRoute.lastIndexOf("/"));
  let newSample = currentRoute.slice(0, 20);
  const redirectProfile = (item, id) => {
    let reRoute = window.open(`/startup-profile/${item}`, "_blank");
    reRoute.id = item;
  };
  // const redirectProfile = (dpiitNo) => {
  //   let reRoute = window.open("/startup-profile", "_blank");
  //   reRoute.id = dpiitNo;

  // };

  return (
    <SecondaryDisplaySurface>
      <Grid container spacing={3}>
        <Grid item sm={6} md={3} className={classes.secondaryImageContainer}>
          <div className="newuserTooltip">
            <img
              className={classes.personImage}
              src={
                props?.data?.startup?.logo !== null
                  ? props?.data?.startup?.logo
                  : hashImage
              }
              alt="gaiaimage"
              style={{ cursor: "pointer" }}
              // onClick={() => ViewProfile(item?.email_id, item?.id)}
              onClick={() => {
                // setIndexCounter(item.requestId);
                redirectProfile(props?.data?.startup?.dippNumber);
              }}
            />
            <span
              className="tooltiptext  tooltip-bottom"
              style={{ top: "140px", left: "36px", width: "160px" }}
            >
              View Startup Profile
            </span>
          </div>
          <Typography
            style={{ cursor: "pointer" }}
            onClick={() => {
              // setIndexCounter(item.requestId);
              redirectProfile(props?.data?.startup?.dippNumber);
            }}
            className={classes.underTypography}
          >
            STARTUP
          </Typography>
        </Grid>
        <Grid item container spacing={3} sm={12} md={9}>
          <Grid item xs={6} md={3}>
            <Typography className={classes.headingfourone}>COMPANY</Typography>
            <Typography className={classes.headingfourtwo}>
              {props?.data?.startup?.organization_name}
            </Typography>
          </Grid>
          <Grid item xs={6} md={3}>
            <Typography className={classes.headingfourone}>CONTACT</Typography>
            <Typography className={classes.headingfourtwo}>
              {props?.data?.startup?.applicant_name}
            </Typography>
          </Grid>
          <Grid item xs={6} md={3}>
            <Typography className={classes.headingfourone}>STATE</Typography>
            <Typography className={classes.headingfourtwo}>
              {props?.data?.startup?.state}
            </Typography>
          </Grid>
          <Grid item xs={6} md={3}>
            <Typography className={classes.headingfourone}>CITY</Typography>
            <Typography className={classes.headingfourtwo}>
              {props?.data?.startup?.city}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Divider className={classes.secondaryDisplayDivider} />
          </Grid>
          <Grid item xs={12}>
            <Typography className={classes.headingfourone}>EMAIL</Typography>
            <Typography
              className={classes.headingfourtwo}
              style={{ wordWrap: "break-word" }}
            >
              {props?.data?.startup?.email}
            </Typography>
          </Grid>
          <Grid item xs={12}></Grid>
        </Grid>
      </Grid>
    </SecondaryDisplaySurface>
  );
};

const SecondDisplaySurface = (props) => {
  class AesUtil {
    constructor(keySize, iterationCount) {
      this.keySize = keySize / 32;
      this.iterationCount = iterationCount;
    }
  
    generateKey = function (salt, passPhrase) {
      let key = CryptoJS.PBKDF2(passPhrase, CryptoJS.enc.Hex.parse(salt), {
        keySize: this.keySize,
        iterations: this.iterationCount,
      });
      return key;
    };
  
    encrypt = function (salt, iv, passPhrase, plainText) {
      let key = this.generateKey(salt, passPhrase);
      let encrypted = CryptoJS.AES.encrypt(plainText, key, {
        iv: CryptoJS.enc.Hex.parse(iv),
      });
      return encrypted.ciphertext.toString(CryptoJS.enc.Base64);
    };
  }
  const encryptAES2 = (text, key) => {
    let iv = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
    let salt = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
  
    let aesUtil = new AesUtil(128, 1000);
    let ciphertext = aesUtil.encrypt(salt, iv, key, text);
  
    let aesText = iv + "::" + salt + "::" + ciphertext;
    
    return btoa(aesText);
  };
  const classes = useStyles();
  const params = useParams();
  const history = useHistory();

  const currentRoute = window.location.href;
  let sample;
  sample = currentRoute.slice(0, currentRoute.lastIndexOf("/"));
  let newSample = currentRoute.slice(0, 20);
  
  const ViewProfile = (item, id) => {
    // setSelectedRow(id);
    // let reRoute = window.open(`/mentor-profile/${item}`, "_blank");
    let reRoute = window.open(`/mentor-profile/${encryptAES2(item,PROFILE_KEY)}`, "_blank");
    reRoute.id = item;
    // history.push({
    //   pathname: `/mentor-profile/${item.email}`,
    //   state: { prevPage: "mentorPage",data:item },
    // });
  };

  return (
    <SecondaryDisplaySurface>
      <Grid container spacing={3}>
        <Grid item sm={6} md={3} className={classes.secondaryImageContainer}>
          <div className="newuserTooltip">
            <img
              className={classes.personImage}
              src={props?.data?.mentor?.image || hashImage}
              alt="gaiaimage"
              style={{ cursor: "pointer" }}
              onClick={() =>
                ViewProfile(props?.data?.mentor?.email, props?.data?.mentor?.id)
              }
            />
            <span
              className="tooltiptext  tooltip-bottom"
              style={{ top: "140px", left: "36px", width: "160px" }}
            >
              View Mentor Profile
            </span>
          </div>
          <Typography
            style={{ cursor: "pointer" }}
            onClick={() =>
              ViewProfile(props?.data?.mentor?.email, props?.data?.mentor?.id)
            }
            className={classes.underTypography}
          >
            MENTOR
          </Typography>
        </Grid>
        <Grid item container spacing={3} sm={12} md={9}>
          <Grid item xs={6} md={3}>
            <Typography className={classes.headingfourone}>NAME</Typography>
            <Typography className={classes.headingfourtwo}>
              {props?.data?.mentor?.name}
            </Typography>
          </Grid>
          <Grid item xs={6} md={3}>
            <Typography className={classes.headingfourone}>COUNTRY</Typography>
            <Typography className={classes.headingfourtwo}>
              {props?.data?.mentor?.country}
            </Typography>
          </Grid>
          <Grid item xs={6} md={3}>
            <Typography className={classes.headingfourone}>STATE</Typography>
            <Typography className={classes.headingfourtwo}>
              {props?.data?.mentor?.state}
            </Typography>
          </Grid>
          <Grid item xs={6} md={3}>
            <Typography className={classes.headingfourone}>CITY</Typography>
            <Typography className={classes.headingfourtwo}>
              {props?.data?.mentor?.city}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Divider className={classes.secondaryDisplayDivider} />
          </Grid>
          <Grid item xs={12}>
            <Typography className={classes.headingfourone}>EMAIL</Typography>
            <Typography
              style={{ wordWrap: "break-word" }}
              className={classes.headingfourtwo}
            >
              {props?.data?.mentor?.email}
            </Typography>
          </Grid>
          <Grid item xs={12}></Grid>
        </Grid>
      </Grid>
      <div className="newuserTooltip">
        {/* <IconButton
        style={{
          backgroundColor: "rgba(0,0,0,0.08)",
          position: "absolute",
          bottom: 15,
          right: 15,
        }}
        onClick={() => {
          const currentRoute = window.location.href;
          let sample;
          sample = currentRoute.slice(0, currentRoute.lastIndexOf("startup"));
          let reRoute = window.open(sample + "chatBox", "_blank");
          reRoute.receiverId = props.data.mentor.id;
          reRoute.receiverInfo = props?.data?.mentor;
          // history.push({
          //   pathname:"/chatBox",
          //   state:props?.data?.mentor
          // })
          // alert("✔️ This works on every component!");
        }}
      >
        <MailIcon style={{ color: "#3ac2d7" }} />
      </IconButton> */}
        <span className="tooltiptext tooltip-bottom messageMentorTooltip">
          Send Message to Mentor
        </span>
      </div>
    </SecondaryDisplaySurface>
  );
};

const SessionButton = (props) => {
  const classes = useStyles();

  return (
    <Button
      style={props.disabled && { opacity: 0.7 }}
      className={classes.sessionButton}
      fullWidth={props.fullWidth}
      onClick={props.onClick}
    >
      {props.children}
    </Button>
  );
};

const MentorEngagementSummary = (props) => {
  const html = document.getElementsByTagName("html")[0];
  const {
    getSessionSummaryData,
    postSessionSummaryData,
    getSummaryMomData,
    getUploadDocumentList,
    getDocumentList,
    getStartUpFeedback,
    getStartUpFeedBackData,
    getEngagementNotesData,
    getEngagementNotes,
    postStartUpFeedback,
    getStepperTooltipData,
    getStepperData,
  } = props;
  const classes = useStyles();
  const [Heading, setHeading] = useState();
  const [showVideo, setShowVideo] = useState();
  const [InstructionswithRole, setInstructionswithRole] = useState();
  const [SelectPage, setSelectPage] = useState();
  const [modalOpen, setModalOpen] = useState(false);
  const [isParentData, setIsParentData] = useState("");
  const [isModalShown, setIsModalShown] = useState(false);
  const [isModalShown2, setIsModalShown2] = useState(false);
  const [isModalShown3, setIsModalShown3] = useState(false);
  const [engagementDuration, setEngagementDuration] = useState(8);
  const [engagementSessions, setEngagementSessions] = useState(4);
  const [data, setData] = useState();
  const [uploadDocLimit, setUploadDocLimit] = useState(0);
  const [sessionList, setSessionList] = useState();
  const [sessionModalOpen, setSessionModalOpen] = useState(false);
  const [sessionModalChild, setSessionModalChild] = useState(false);
  const [sessionMomModalOpen, setSessionMomModalOpen] = useState(false);
  const [sessionMomChildData, setSessionMomChildData] = useState(false);
  const [sessionMomChildData2, setSessionMomChildData2] = useState(false);
  const [sessionModalData, setSessionModalData] = useState(null);
  const [sessionMomModalData, setSessionMomModalData] = useState(null);
  const [mentorFeedbackModalOpen, setMentorFeedbackModalOpen] = useState(false);
  const [mentorFeedbackParent, setMentorFeedbackParent] = useState(false);
  const [engagementNotesModalOpen, setEngagementNotesModalOpen] =
    useState(false);
  const [summaryModalOpen, setSummaryModalOpen] = useState(false);
  const [summaryModalData, setSummaryModalData] = useState(null);
  const [summaryFullModalData, setSummaryFullModalData] = useState(null);
  const [completedSessionList, setCompletedSessionList] = useState();
  const [summarySessionId, setSummarySessionId] = useState();
  const [mentorshipStatus, setMentorshipStatus] = useState("ONGOING");
  const [uploadDocumentParent, setUploadDocumentParent] = useState(false);
  const [didDataChange, setDidDataChange] = useState(0);
  const [editModalVisibility, setEditModalVisibility] = useState(false);
  const [checkFillNotesList, setCheckFillNotesList] = useState(false);
  const [checkOppositeFillNotesList, setCheckOppositeFillNotesList] =
    useState(false);
  const [chatBoxModalOpen, setChatBoxModalOpen] = useState(false);
  const [sessionMomList, setSessionMomList] = useState([]);
  const [engagementParentData, setEngagementParentData] = useState(false);
  const [engagementNotesDataModalOpen, setEngagementNotesDataModalOpen] =
    useState(false);
  const [modalVisibileParent, setModalVisibileParent] = useState(false);
  const [checkSessionStatus, setCheckSessionStatus] = useState(false);
  const [bottomTableItem, setBottleTableItem] = useState("");
  const [showAllSummary, setShowAllSummary] = useState(false);
  const [isShown, setIsShown] = useState(false);
  const setModalIsOpenToTrue = () => {
    setIsShown(!isShown);
  };
  // useEffect(()=>{
  //
  // },[])

  useEffect(() => {
    html.style.overflow = "auto";
    setTimeout(() => {
      // axios({
      //   url: MENTORSHIP_SESSIONS_LIST,
      //   method: "POST",
      //   data: {
      //     mentorshipId: params.mentorshipId,
      //   },
      // })
      api
        .POST(MENTORSHIP_SESSIONS_LIST, {
          mentorshipId: params.mentorshipId,
        })
        .then((res) => {
          let test = res.data.data;
          if (res?.data?.data?.length == 0) {
            setCheckSessionStatus(false);
          } else {
            let counter2 = 0;
            test.forEach((item, index) => {
              if (item.sessionStatus !== "COMPLETED") counter2++;
            });
            if (counter2 > 0) setCheckSessionStatus(false);
            else if (counter2 == 0) setCheckSessionStatus(true);
          }
        }, 150);

      // setTimeout(()=>{
      //   window.location.reload();
      // },1000)

      setModalVisibileParent(false);
      // setSessionList(res.data?.data);
    });
    // if(sessionList?.length == 1)
    // window.location.reload();
  }, [modalVisibileParent]);
  const params = useParams();
  const valueoflogin = JSON.parse(localStorage.getItem("SavedLoggedInData"));
  useEffect(() => {
    let paramsData = {
      userId: JSON.parse(localStorage.getItem("SavedLoggedInData"))?.id,
      mentorshipId: params.mentorshipId,
    };
    getEngagementNotes(paramsData);
  }, []);
  useEffect(() => {
    let paramsData = {
      userId: JSON.parse(localStorage.getItem("SavedLoggedInData"))?.id,
      mentorshipId: params.mentorshipId,
    };
    getEngagementNotes(paramsData);
  }, [engagementParentData]);
  useEffect(() => {
    if (sessionList !== undefined) {
      sessionList.forEach((item) => {
        getSummaryMomReturn(item.scheduleId);
      });
    }
  }, [sessionList]);
  useEffect(() => {
    listingAPI();
    setTimeout(() => {
      if (sessionList !== undefined) {
        sessionList.forEach((item) => {
          getSummaryMomReturn(item.scheduleId);
        });
      }
      fetchCompletedDataList();
    }, 500);
    setSessionMomChildData2(false);
  }, [sessionMomChildData2]);
  const fetchCompletedDataList = () => {
    // axios({
    //   url: MENTORSHIP_SESSIONS_LIST,
    //   method: "POST",
    //   data: {
    //     mentorshipId: params.mentorshipId,
    //     sessionStatus: "COMPLETED",
    //   },
    // })
    api
      .POST(MENTORSHIP_SESSIONS_LIST, {
        mentorshipId: params.mentorshipId,
        sessionStatus: "COMPLETED",
      })
      .then((res) => {
        setCompletedSessionList(res.data?.data);
      })
      .catch((err) => {});
  };
  const getSummaryMomReturn = (sessionId) => {
    var responseData;
    let data = {
      mentorshipId: params.mentorshipId,
      sessionId: sessionId,
    };
    // axios({
    //   url: GET_SUMMARY_DATA,
    //   method: "POST",
    //   data: data,
    // })
    api.POST(GET_SUMMARY_DATA, data).then((res) => {
      responseData = res.data.data;
      if (sessionList.length >= sessionMomList.length)
        setSessionMomList((oldArray) => [...oldArray, responseData]);
    });
  };
  useEffect(() => {
    // axios({
    //   url: MENTORSHIP_SESSIONS_LIST,
    //   method: "POST",
    //   data: {
    //     mentorshipId: params.mentorshipId,
    //   },
    // })
    api
      .POST(MENTORSHIP_SESSIONS_LIST, {
        mentorshipId: params.mentorshipId,
      })
      .then((res) => {
        let test = res.data.data;
        let counter = 0;
        let counter2 = 0;
        let counter3 = 0;
        test.forEach((item, index) => {
          if (item.momStartupSubmitted === false) counter++; // checks startup's notes filled or not submitted
          if (item.sessionStatus !== "COMPLETED") counter2++; // checks startup's sessions are completed
          if (item.momMentorSubmitted === false) counter3++;
        });
        if (counter > 0) setCheckFillNotesList(false);
        else if (counter == 0) setCheckFillNotesList(true);
        if (counter2 > 0) setCheckSessionStatus(false);
        else if (counter2 == 0) setCheckSessionStatus(true);
        if (counter3 > 0) setCheckOppositeFillNotesList(false);
        else if (counter3 == 0) setCheckOppositeFillNotesList(true);
        // let counter = 0;
        // test.forEach((item) => {
        //   if (item?.momStartupSubmitted === false) counter++;
        // });
        // if (counter > 0) setCheckFillNotesList(false);
        // else if (counter == 0) setCheckFillNotesList(true);
      })
      .catch((err) => {});
  }, []);
  useEffect(() => {
    if (sessionMomChildData) {
      setTimeout(() => {
        listingAPI();
      }, 500);
      setSessionMomChildData(false);
    }
  }, [sessionMomChildData]);
  useEffect(() => {
    let paramsReq = {
      mentorshipId: params.mentorshipId,
    };
    getStartUpFeedback(paramsReq);
  }, []);
  useEffect(() => {
    let paramsReq = {
      mentorshipId: params.mentorshipId,
    };
    getStartUpFeedback(paramsReq);
  }, [mentorFeedbackParent]);
  useEffect(() => {
    setTimeout(() => {
      if (sessionModalChild) {
        listingAPI();
        setSessionModalChild(false);
      }
    }, 1000);
  }, [sessionModalChild]);
  useEffect(() => {
    if (uploadDocumentParent) {
      const getMentorshipSummaryData = new Promise((resolve, reject) => {
        // axios({
        //   url: MENTORSHIP_ENGAGEMENT_SUMMARY,
        //   method: "POST",
        //   data: {
        //     id: params.mentorshipId,
        //   },
        // })
        api
          .POST(MENTORSHIP_ENGAGEMENT_SUMMARY, {
            id: params.mentorshipId,
          })
          .then((res) => {
            if (res.data?.data) {
              setData(res?.data?.data);
              setEngagementDuration(res?.data?.data?.weekDuartion);
              setEngagementSessions(res?.data?.data?.totalSessions);
              let counter = 0;
              let filterLimit = res?.data?.data?.documents;
              filterLimit.forEach((element) => {
                if (
                  element.uploadedBy ==
                  JSON.parse(localStorage.getItem("SavedLoggedInData"))
                    .applicant_name
                ) {
                  counter++;
                }
              });
              setUploadDocLimit(counter);
            }
            resolve();
          })
          .catch((err) => {
            reject();
          });
      });
      setUploadDocumentParent(false);
      // getUploadDocumentList();
      // setUploadDocumentParent(false);
    }
  }, [uploadDocumentParent]);
  const completeEngagmentFn = (modalType) => {
    let data;
    if (
      localStorage.getItem("SavedLoggedInData") &&
      JSON.parse(localStorage.getItem("SavedLoggedInData"))?.role !== "Admin"
    ) {
      // if (checkFillNotesList)
      //   setMentorFeedbackModalOpen(true);
      // else
      //   swal(
      //     "Please Fill Session Notes",
      //     "To Complete Engagement please fill Session Notes.",
      //     "info"
      //   );
      // axios({
      //   url: MENTORSHIP_SESSIONS_LIST,
      //   method: "POST",
      //   data: {
      //     mentorshipId: params.mentorshipId,
      //   },
      // })
      api
        .POST(MENTORSHIP_SESSIONS_LIST, {
          mentorshipId: params.mentorshipId,
        })
        .then((res) => {
          setSessionList(res.data?.data);
          if (res.status === 200) {
            data = res.data.data;
            let counter = 0;
            let counter2 = 0;
            let counter3 = 0;
            data.forEach((item, index) => {
              if (item.momStartupSubmitted === false) counter++; // checks startup's notes filled or not submitted
              if (item.sessionStatus !== "COMPLETED") counter2++; // checks startup's sessions are completed
              if (item.momMentorSubmitted === false) counter3++;
            });
            if (counter > 0) setCheckFillNotesList(false);
            else if (counter == 0) setCheckFillNotesList(true);
            if (counter2 > 0) setCheckSessionStatus(false);
            else if (counter2 == 0) setCheckSessionStatus(true);
            if (counter3 > 0) setCheckOppositeFillNotesList(false);
            else if (counter3 == 0) setCheckOppositeFillNotesList(true);
            if (counter === 0 && counter3 === 0) {
              // setMentorFeedbackModalOpen(true);
              if (modalType === "feedback") setMentorFeedbackModalOpen(true);
              else if (modalType === "notes")
                setEngagementNotesDataModalOpen(true);
            } else
              swal(
                !(counter3 === 0) && counter === 0
                  ? "Mentor's Session Note Not Submitted"
                  : "Please Fill Session Notes",
                !(counter3 === 0) && counter === 0
                  ? "Please wait till Mentor Completes their Session Notes"
                  : "To Complete Engagement please fill Session Notes.",
                "info"
              );
          } else {
          }
        });
    }
  };
  const scheduleSessionCheck = () => {
    let data;
    // axios({
    //   url: MENTORSHIP_SESSIONS_LIST,
    //   method: "POST",
    //   data: {
    //     mentorshipId: params.mentorshipId,
    //   },
    // })
    api
      .POST(MENTORSHIP_SESSIONS_LIST, {
        mentorshipId: params.mentorshipId,
      })
      .then((res) => {
        setSessionList(res.data?.data);
        if (res.status === 200) {
          data = res.data.data;
          let counter = 0;
          let counter2 = 0;
          let counter3 = 0;
          data.forEach((item, index) => {
            if (item.momStartupSubmitted === false) counter++; // checks startup's notes filled or not submitted
            if (item.sessionStatus !== "COMPLETED") counter2++; // checks startup's sessions are completed
            if (item.momMentorSubmitted === false) counter3++; // checks mentor's notes filled or not submitted
          });
          if (counter > 0) setCheckFillNotesList(false);
          else if (counter == 0) setCheckFillNotesList(true);
          if (counter2 > 0) setCheckSessionStatus(false);
          else if (counter2 == 0) setCheckSessionStatus(true);
          if (counter3 > 0) setCheckOppositeFillNotesList(false);
          else if (counter3 == 0) setCheckOppositeFillNotesList(true);
          if (counter2 > 0) {
            swal(
              "Complete Existing Session",
              "Please complete or delete the existing session to schedule a new one",
              "info"
            );
          } else if (counter2 == 0 && counter > 0) {
            swal(
              "Please Fill Session Notes",
              "To Complete Engagement please fill Session Notes.",
              {
                icon: "info",
                buttons: {
                  delete: {
                    text: "FILL NOW",
                  },
                  decline: {
                    text: "CANCEL",
                  },
                },
              }
            ).then((value) => {
              if (value === "delete") {
                setSessionMomModalOpen(true);
                setSummarySessionId(
                  sessionList[sessionList?.length - 1].scheduleId
                );
                // setSummarySessionData(sessionList[sessionList?.length - 1]);
              }
            });
          } else if (counter2 == 0 && counter == 0 && counter3 > 0) {
            swal(
              "Mentor's Session Note Not Submitted",
              "Please wait till Mentor Completes filling their Session Notes",
              "info"
            );
          } else if (counter2 == 0 && counter3 == 0 && counter == 0) {
            setModalOpen(true);
          }
          // resolve();
          // return (res.data.data,counter,counter2,counter3)
          // let ele = res.data.data?.find((ele) => {
          //   if (ele.sessionStatus === "SCHEDULED") {
          //     return true;
          //   }
          // });
          // if (ele) {
          //   swal(
          //     "Complete Existing Session",
          //     "Please complete or delete the existing session to schedule a new one",
          //     "info"
          //   );
          // } else if (
          //   (counter === 0 && !ele && counter3 === 0) ||
          //   data.length <= 0
          // ) {
          //   setModalOpen(true);
          // } else
          //   swal(
          //     !(counter3 === 0) && counter === 0
          //       ? "Mentor's Session Note Not Submitted"
          //       : "Please Fill Session Notes",
          //     !(counter3 === 0) && counter === 0
          //       ? "Please wait till Mentor Completes their Session Notes"
          //       : "To Complete Engagement please fill Session Notes.",
          //     {
          //       icon: "info",
          //       buttons: {
          //         delete: {
          //           text: "FILL NOW",
          //         },
          //         decline: {
          //           text: "CANCEL",
          //         },
          //       },
          //     }
          //   ).then((value) => {
          //     if (value === "delete") {
          //       setSessionMomModalOpen(true);
          //       setSummarySessionId(
          //         sessionList[sessionList?.length - 1].scheduleId
          //       );
          //     }
          //   });
        }
      })
      .catch((err) => {
        // reject();
      });
    // return data
  };
  const listingAPI = () => {
    const getMentorshipSessionsList = new Promise((resolve, reject) => {
      // axios({
      //   url: MENTORSHIP_SESSIONS_LIST,
      //   method: "POST",
      //   data: {
      //     mentorshipId: params.mentorshipId,
      //   },
      // })
      api
        .POST(MENTORSHIP_SESSIONS_LIST, {
          mentorshipId: params.mentorshipId,
        })
        .then((res) => {
          setSessionList(res.data?.data);
          let test = res.data.data;
          let counter = 0;
          let counter2 = 0;
          let counter3 = 0;
          test.forEach((item, index) => {
            if (item.momStartupSubmitted === false) counter++; // checks startup's notes filled or not submitted
            if (item.sessionStatus !== "COMPLETED") counter2++; // checks startup's sessions are completed
            if (item.momMentorSubmitted === false) counter3++;
          });
          if (counter > 0) setCheckFillNotesList(false);
          else if (counter == 0) setCheckFillNotesList(true);
          if (counter2 > 0) setCheckSessionStatus(false);
          else if (counter2 == 0) setCheckSessionStatus(true);
          if (counter3 > 0) setCheckOppositeFillNotesList(false);
          else if (counter3 == 0) setCheckOppositeFillNotesList(true);
          resolve();
        })
        .catch((err) => {
          reject();
        });
    });
  };
  useEffect(() => {
    if (sessionMomChildData) {
      const getMentorshipSessionsList = new Promise((resolve, reject) => {
        // axios({
        //   url: MENTORSHIP_SESSIONS_LIST,
        //   method: "POST",
        //   data: {
        //     mentorshipId: params.mentorshipId,
        //   },
        // })
        api
          .POST(MENTORSHIP_SESSIONS_LIST, {
            mentorshipId: params.mentorshipId,
          })
          .then((res) => {
            setSessionList(res.data?.data);
            resolve();
          })
          .catch((err) => {
            reject();
          });
      });
      setSessionMomChildData(false);
    }
  }, [sessionMomChildData]);
  useEffect(() => {
    // props.openLoader();

    const getMentorshipSummaryData = new Promise((resolve, reject) => {
      // axios({
      //   url: MENTORSHIP_ENGAGEMENT_SUMMARY,
      //   method: "POST",
      //   data: {
      //     id: params.mentorshipId,
      //   },
      // })
      api
        .POST(MENTORSHIP_ENGAGEMENT_SUMMARY, {
          id: params.mentorshipId,
        })
        .then((res) => {
          if (res.data?.data) {
            setData(res?.data?.data);
            setEngagementDuration(res?.data?.data?.weekDuartion);
            setEngagementSessions(res?.data?.data?.totalSessions);
            let counter = 0;
            let filterLimit = res?.data?.data?.documents;
            filterLimit.forEach((element) => {
              if (
                element.uploadedBy ==
                JSON.parse(localStorage.getItem("SavedLoggedInData"))
                  .applicant_name
              ) {
                counter++;
              }
            });
            setUploadDocLimit(counter);
          }
          resolve();
        })
        .catch((err) => {
          reject();
        });
    });
    const getMentorshipSessionsList = new Promise((resolve, reject) => {
      // axios({
      //   url: MENTORSHIP_SESSIONS_LIST,
      //   method: "POST",
      //   data: {
      //     mentorshipId: params.mentorshipId,
      //   },
      // })
      api
        .POST(MENTORSHIP_SESSIONS_LIST, {
          mentorshipId: params.mentorshipId,
        })
        .then((res) => {
          setSessionList(res.data?.data);
          resolve();
        })
        .catch((err) => {
          reject();
        });
    });

    const getCompletedSessionsList = new Promise((resolve, reject) => {
      // axios({
      //   url: MENTORSHIP_SESSIONS_LIST,
      //   method: "POST",
      //   data: {
      //     mentorshipId: params.mentorshipId,
      //     sessionStatus: "COMPLETED",
      //   },
      // })
      api
        .POST(MENTORSHIP_SESSIONS_LIST, {
          mentorshipId: params.mentorshipId,
          sessionStatus: "COMPLETED",
        })
        .then((res) => {
          setCompletedSessionList(res.data?.data);
          resolve();
        })
        .catch((err) => {
          reject();
        });
    });

    Promise.all([
      getMentorshipSessionsList,
      getMentorshipSummaryData,
      getCompletedSessionsList,
    ])
      .then((values) => {
        // props.closeLoader();
      })
      .catch((err) => {
        // props.closeLoader();
      });
  }, []);
  useEffect(() => {
    setTimeout(() => {
      // props.openLoader();

      const getMentorshipSummaryData = new Promise((resolve, reject) => {
        // axios({
        //   url: MENTORSHIP_ENGAGEMENT_SUMMARY,
        //   method: "POST",
        //   data: {
        //     id: params.mentorshipId,
        //   },
        // })
        api
          .POST(MENTORSHIP_ENGAGEMENT_SUMMARY, {
            id: params.mentorshipId,
          })
          .then((res) => {
            if (res.data?.data) {
              setData(res?.data?.data);
              setEngagementDuration(res?.data?.data?.weekDuartion);
              setEngagementSessions(res?.data?.data?.totalSessions);
            }
            resolve();
          })
          .catch((err) => {
            reject();
          });
      });

      const getMentorshipSessionsList = new Promise((resolve, reject) => {
        // axios({
        //   url: MENTORSHIP_SESSIONS_LIST,
        //   method: "POST",
        //   data: {
        //     mentorshipId: params.mentorshipId,
        //   },
        // })
        api
          .POST(MENTORSHIP_SESSIONS_LIST, {
            mentorshipId: params.mentorshipId,
          })
          .then((res) => {
            setSessionList(res.data?.data);
            resolve();
          })
          .catch((err) => {
            reject();
          });
      });

      const getCompletedSessionsList = new Promise((resolve, reject) => {
        // axios({
        //   url: MENTORSHIP_SESSIONS_LIST,
        //   method: "POST",
        //   data: {
        //     mentorshipId: params.mentorshipId,
        //     sessionStatus: "COMPLETED",
        //   },
        // })
        api
          .POST(MENTORSHIP_SESSIONS_LIST, {
            mentorshipId: params.mentorshipId,
            sessionStatus: "COMPLETED",
          })
          .then((res) => {
            setCompletedSessionList(res.data?.data);
            resolve();
          })
          .catch((err) => {
            reject();
          });
      });

      Promise.all([
        getMentorshipSessionsList,
        getMentorshipSummaryData,
        getCompletedSessionsList,
      ])
        .then((values) => {
          // props.closeLoader();
        })
        .catch((err) => {
          // props.closeLoader();
        });
    }, 1500);
  }, [didDataChange]);

  const setSessionCompleted = (scheduleId) => {
    props.openLoader();
    // axios({
    //   url: MENTORSHIP_SESSION_UPDATE,
    //   method: "POST",
    //   data: {
    //     scheduleId,
    //     sessionStatus: "COMPLETED",
    //   },
    // })
    api
      .POST(MENTORSHIP_SESSION_UPDATE, {
        scheduleId,
        sessionStatus: "COMPLETED",
      })
      .then((res) => {
        setDidDataChange(didDataChange + 1);
        props.closeLoader();
      })
      .catch((err) => {
        // props.closeLoader();
      });
  };
  const getSummaryMom = (sessionId) => {
    let data = {
      mentorshipId: params.mentorshipId,
      sessionId: sessionId,
    };
    // axios({
    //   url: GET_SUMMARY_DATA,
    //   method: "POST",
    //   data: data,
    // })
    api.POST(GET_SUMMARY_DATA, data).then((res) => {
      setSummaryModalData(res.data.data.startupSummary);
      setSummaryFullModalData(res.data.data);
    });
    getSessionSummaryData(data);
  };
  const handleEngagementConfirmation = (
    newEngagementDuration,
    newEngagementSession
  ) => {
    // if (!engagementDuration || !engagementSessions) {
    //   return;
    // }
    let data = {
      mentorshipId: params.mentorshipId,
    };
    if (newEngagementDuration) {
      data.week_duartion = parseInt(newEngagementDuration);
    } else {
      data.week_duartion = parseInt(engagementDuration);
    }
    if (newEngagementSession) {
      data.no_of_sessions = parseInt(newEngagementSession);
    } else {
      data.no_of_sessions = parseInt(engagementSessions);
    }
    // axios({
    //   url: MENTORSHIP_SESSION_PLAN_CONFIRM,
    //   method: "POST",
    //   data,
    // })
    api
      .POST(MENTORSHIP_SESSION_PLAN_CONFIRM, data)
      .then((res) => {
        swal(
          "Success",
          "Your Mentorship Plan Confirmed Successfully!",
          "success"
        );
        setDidDataChange(didDataChange + 1);
      })
      .catch((err) => {
        swal(
          "Something Went Wrong!",
          "Mentorship Plan not Confirmed!",
          "error"
        );
      });
  };
  useEffect(() => {
    getStepperTooltipData();
  }, []);
  useEffect(() => {
    setHeading(getStepperData?.Guidedinstructions[0].Heading);
    setInstructionswithRole(
      getStepperData?.Guidedinstructions[0].InstructionswithRole
    );
    setSelectPage(getStepperData?.Guidedinstructions[0].SelectPage);
  }, [getStepperData]);
  const selectInputRef = useRef();
  const [defaultValue, setDefaultValue] = useState({
    value: "SCHEDULED",
    label: "SCHEDULED",
  });

  const onClear = () => {
    setDefaultValue({ value: "SCHEDULED", label: "SCHEDULED" }); // this will reset the dropdown value
  };
  const newfunctionTime = (
    item
  ) => {
    let currentYear=  moment().format("YYYY") 
    let currentMonth=  moment().format("MM") 
    let presentTime = moment(new Date()).format("DD-MM-YYYY HH:mm A")
    let ternaryValue= item?.sessionStartDate !== undefined && item?.sessionStartDate !== null && item?.sessionStartDate !== "" ? item?.sessionStartDate  :  item?.sessionStart
    let sessionYear = moment(ternaryValue).format("YYYY");
    let sessionMonth = moment(ternaryValue).format("MM");
    let sessionTime = moment(ternaryValue);
    let sessionDuration = item?.sessionDuration;
    let sessionStartTime = moment(sessionTime).format("DD-MM-YYYY HH:mm A");
    let sessionDate = moment(ternaryValue).format("DD-MM-YYYY");
    let presentDate = moment().format("DD-MM-YYYY");
    let beforetime1 = moment(sessionStartTime).subtract(60, "minutes").format("DD-MM-YYYY HH:mm A");
    // let beforetime1 = moment(sessionStartTime, "DD-MM-YYYY HH:mm A")
    // .subtract(60, "minutes")
    // .format("DD-MM-YYYY HH:mm A");
    let endTime = moment(sessionTime).add(sessionDuration + 1,'hours').format("DD-MM-YYYY HH:mm A");
  
      if(sessionYear >currentYear || sessionYear == currentYear && sessionMonth>currentMonth){
    swal({
        title: "Meeting Not Started",
        text: `Cannot Complete meeting before scheduled time.`,
        icon: "error",
        // timer: 1500,
        // buttons: false,
      });
      }
     else if( sessionYear == currentYear && sessionMonth < currentMonth){
      setSessionCompleted(item?.scheduleId);
          }
      else if(currentMonth == sessionMonth ){
       if(presentDate > sessionDate){
        setSessionCompleted(item?.scheduleId);
       }
       else   if(sessionDate === presentDate )
       {
        if(presentTime  >= beforetime1 && endTime >= presentTime)
        { 
          swal({
            title: "Meeting Not Completed",
            text: `Cannot Commplete Session before scheduled time.`,
            icon: "error",
            // timer: 1500,
            // buttons: false,
          });
                }
        else if(presentTime < beforetime1)
        {
            swal({
              title: "Meeting Not Started",
              text: `Cannot Complete meeting before scheduled time.`,
              icon: "error",
              // timer: 1500,
              // buttons: false,
            });
           
        }
        else if(endTime < presentTime) {
          setSessionCompleted(item?.scheduleId);
  
        }
       }
  
       else {
        swal({
          title: "Meeting Not Started",
          text: `Cannot Complete meeting before scheduled time.`,
          icon: "error",
          // timer: 1500,
          // buttons: false,
        });
       }
      }
      else if(sessionYear < currentYear){
                swal({
            title: "Scheduled Time Over",
          text: `You cannot join meeting.`,
          icon: "error",
          // timer: 1500,
          // buttons: false,
        });
      }
  };
  return (
    <Box className={clsx(classes.root, "forhiditooltip45")}>
      <div className="iconWith-heading headingdirection003">
        <div style={{ width: "100%" }}>
          <Typography
            className={clsx(
              classes.headingOne,
              "homepageSecondHeader",
              "headi01"
            )}
          >
            MAARG Portal by Startup India
          </Typography>
          <Typography
            className={clsx(
              classes.headingTwo,
              "homepageFirstHeader",
              "headi02"
            )}
          >
            MENTORSHIP ENGAGEMENT SUMMARY
          </Typography>
        </div>
        <div
          className="tooltipshow eyeIcon"
          // onClick={() => {
          //   html.style.overflow = "hidden";
          // }}
        >
          <div className="newuserTooltip">
            <img
              className="iconbtn top-btn"
              src={iconTooltip}
              onClick={() => {
                setModalIsOpenToTrue();
                if (html.style.overflow == "auto") {
                  html.style.overflow = "hidden";
                } else {
                  html.style.overflow = "auto";
                }
              }}
              width={60}
            />
            <span
              className="tooltiptext tooltip-bottom "
              style={{ width: "130px", top: "50px", left: "20px" }}
            >
              View Instructions
            </span>
          </div>
        </div>
        {isShown && (
          <div>
            <AnimeList
              setModalIsOpenToTrue={setModalIsOpenToTrue}
              Heading={Heading}
              InstructionswithRole={InstructionswithRole}
              SelectPage={SelectPage}
            />
          </div>
        )}
      </div>

      <UpperDisplaySurface data={data?.mentorRequest?.requestJson} />
      {data?.createdByCohort && <UpperDisplaySurface2 data={data} />}

      <Box className={classes.secondaryDisplayContainer}>
        <Grid container spacing={3} alignItems="stretch">
          <Grid item xs={12} md={6}>
            <FirstDisplaySurface data={data} />
          </Grid>
          <Grid item xs={12} md={6}>
            <SecondDisplaySurface data={data} />
          </Grid>
        </Grid>
      </Box>
      {/* <div className="row sessiom-buttons" style={{width:"100%",padding:"5% 10%"}}>
<div className="col col-lg-6 col-md-6 col-sm-12 col-12 top-btn"onClick={() => {
              if (mentorshipStatus === "COMPLETED") {
                return;
              }
              if (!sessionList) {
                return;
              }
              let ele = sessionList?.find((ele) => {
                if (ele.sessionStatus === "SCHEDULED") {
                  return true;
                }
              });
              if (ele) {
                swal(
                  "Complete Existing Session",
                  "Please complete or delete the existing session to schedule a new one",
                  "info"
                );
              } else {
                setModalOpen(true);
              }
            }}  style={{paddingRight:"2%",position:"relative",color:"white"}}><img src={ScheduleSession}/> <a
              className="blue-link-dashboard"
              style={{
                paddingRight: "0px",
               
    
                    fontWeight: 600,
      
                   position: "absolute",
                   top: "48px",
                   left: "288px",
              }}
            >
              {" "}
              SCHEDULE SESSION
            </a></div>
<div className="col col-lg-6 col-md-6 col-sm-12 col-12 top-btn" onClick={()=>{
              const currentRoute = window.location.href;
        let sample;
        sample = currentRoute.slice(0, currentRoute.lastIndexOf("startup"));
        let reRoute = window.open(sample + "chatBox", "_blank");
        reRoute.receiverId = data.mentor.id;
        reRoute.receiverInfo = data?.mentor;
            }}  style={{paddingLeft:"4%",position:"relative",color:"white"}}><img src={SendMessage} /><a
            className="blue-link-dashboard"
            style={{
              paddingRight: "0px",
              position:'absolute',
              fontWeight: "600",
              
              top: "45px",
              left: "329px",
            }}
         
          >
            {" "}
            SEND MESSAGE
          </a></div>
</div>
       */}
      <Box
        style={{
          display: "flex",
          justifyContent: "center",
          width: "100%",
          padding: "30px 24% 0 24%",
        }}
        className={[classes.middleButtonContainer, "middleButtonContainerbtn"]}
      >
        {" "}
        {data?.mentorshipStatus !== undefined &&
          data?.mentorshipStatus !== "CLOSED" &&
          (getEngagementNotesData === undefined ||
            getEngagementNotesData === null) &&
          (getStartUpFeedBackData === undefined ||
            getStartUpFeedBackData === null) &&
          JSON.parse(localStorage.getItem("SavedLoggedInData"))?.role !==
            "Admin" && (
            <>
              <div
                className={clsx(
                  "dashboard-purple-btn top-btn newuserTooltip middleschedule007",
                  classes.middleButtons
                )}
                style={{
                  // cursor: "default",
                  cursor: "pointer",
                  position: "relative",
                }}
                onClick={() => {
                  setModalOpen(true);

                //  scheduleSessionCheck()
                }}
              >
                <div
                  className="blue-link-dashboard engamentSumrry engagementsumButtton08"
                  style={{
                    paddingRight: "0px",
                    fontWeight: "600",
                  }}
                >
                  {" "}
                  SCHEDULE SESSION
                </div>
                <span className="tooltiptext schedule  tooltip-bottom">
                  Schedule Session
                </span>
              </div>{" "}
            </>
          )}
        {JSON.parse(localStorage.getItem("SavedLoggedInData"))?.role !==
          "Admin" && (
          <div
            className={clsx(
              "dashboard-purple-btn top-btn newuserTooltip",
              classes.middleButtons2
            )}
            style={{
              width: "100%",
              // cursor: "default",
              cursor: "pointer",
            }}
            onClick={() => {
              setChatBoxModalOpen(true);
            }}
          >
            <div
              className="blue-link-dashboard engamentSumrry engagementsumButtton08"
              style={{
                paddingRight: "0px",

                fontWeight: "600",
              }}
            >
              {" "}
              SEND MESSAGE
            </div>
            {data?.mentorshipStatus !== undefined &&
            data?.mentorshipStatus !== "CLOSED" &&
            (getEngagementNotesData === undefined ||
              getEngagementNotesData === null) &&
            (getStartUpFeedBackData === undefined ||
              getStartUpFeedBackData === null) &&
            JSON.parse(localStorage.getItem("SavedLoggedInData"))?.role !==
              "Admin" ? (
              <span className="tooltiptext schedule  tooltip-bottom">
                Send Message
              </span>
            ) : (
              <span
                className="tooltiptext   tooltip-bottom"
                style={{ top: "59px", left: "344px" }}
              >
                Send Message
              </span>
            )}
          </div>
        )}
      </Box>

      <Box className={classes.mentorshipOverviewContainer}>
        <img
          src={sideGraphic}
          alt="side graphic 1"
          className={classes.sideGraphic1}
        />
        <Typography
          className={clsx(
            classes.mentorshipOverviewHeading,
            "homepageThirdHeader"
          )}
        >
          Mentorship Overview Session Plan
        </Typography>
        <Grid container spacing={4}>
          <Grid item xs={12} md={4}>
            <Typography
              className={clsx(
                classes.mentorshipOverviewSubheading,
                "homepageThirdDescription"
              )}
            >
              MENTORSHIP
              <br /> ENGAGEMENT <br />
              START DATE
            </Typography>
            {data?.mentorshipStatus !== undefined &&
              data?.mentorshipStatus === "CLOSED" && (
                <>
                  <div className="d-flex justify-content-end fixedMessageSticky">
                    <div className="fixedMessageStickyText2">
                      Your Engagement is Closed
                    </div>
                  </div>
                </>
              )}
            <Box className={classes.mentorshipOverview}>
              <Typography
                className={classes.mentorshipOverviewTy}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {moment(data?.mentorRequest?.mentorAcceptDate).format(
                  "DD-MM-YYYY"
                )}
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} md={4}>
            <Typography
              className={clsx(
                classes.mentorshipOverviewSubheading,
                "homepageThirdDescription"
              )}
            >
              ENGAGEMENT <br />
              DURATION IN <br />
              WEEKS
            </Typography>
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
              }}
            >
              {data?.mentorshipStatus !== "CLOSED" ? (
                <ReactSelect
                  value={{
                    value: engagementDuration,
                    label: `${engagementDuration}`,
                  }}
                  className={classes.select}
                  options={[
                    ...[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(
                      (ele, index) => ({ value: ele, label: ele })
                    ),
                  ]}
                  onChange={(selected) => {
                    setEngagementDuration(selected.value);
                  }}
                  styles={{
                    menu: (styles) => {
                      return {
                        ...styles,
                      };
                    },
                    singleValue: (styles) => ({
                      ...styles,
                      textAlign: "center",
                      paddingLeft: "15%",
                    }),
                    option: (
                      styles,
                      { data, isDisabled, isFocused, isSelected }
                    ) => {
                      return {
                        ...styles,
                        backgroundColor: isSelected
                          ? "#b499c7"
                          : isFocused
                          ? "#e4d7ee"
                          : "white",
                        color: isSelected ? "white" : "black",
                        cursor: isDisabled ? "not-allowed" : "default",
                      };
                    },
                  }}
                />
              ) : (
                <Box className={classes.mentorshipOverview}>
                  <Typography
                    className={classes.mentorshipOverviewTy}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {engagementDuration}
                  </Typography>
                </Box>
              )}
            </div>
          </Grid>
          <Grid item xs={12} md={4}>
            <Typography
              className={clsx(
                classes.mentorshipOverviewSubheading,
                "homepageThirdDescription"
              )}
            >
              ESTIMATED
              <br /> SESSIONS PLANNED <br />
              PER MONTH
            </Typography>

            {data?.mentorshipStatus !== "CLOSED" ? (
              <ReactSelect
                value={{
                  value: engagementSessions,
                  label: `${engagementSessions}`,
                }}
                className={classes.select}
                options={[
                  ...[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15].map(
                    (ele) => ({ value: ele, label: `${ele}` })
                  ),
                ]}
                onChange={(selected) => {
                  setEngagementSessions(selected.value);
                }}
                styles={{
                  menu: (styles) => {
                    return {
                      ...styles,
                    };
                  },
                  singleValue: (styles) => ({
                    ...styles,
                    textAlign: "center",
                    paddingLeft: "15%",
                  }),
                  option: (
                    styles,
                    { data, isDisabled, isFocused, isSelected }
                  ) => {
                    return {
                      ...styles,
                      backgroundColor: isSelected
                        ? "#b499c7"
                        : isFocused
                        ? "#e4d7ee"
                        : "white",
                      color: isSelected ? "white" : "black",
                      cursor: isDisabled ? "not-allowed" : "default",
                    };
                  },
                }}
              />
            ) : (
              <Box className={classes.mentorshipOverview}>
                <Typography
                  className={classes.mentorshipOverviewTy}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {engagementSessions}
                </Typography>
              </Box>
            )}
          </Grid>
        </Grid>
        {data?.mentorshipStatus !== "CLOSED" &&
          JSON.parse(localStorage.getItem("SavedLoggedInData"))?.role !==
            "Admin" && (
            <Box>
              <Tooltip
                classes={{
                  tooltip: classes.tooltip,
                  tooltipArrow: classes.tooltipArrow,
                }}
                PopperProps={{
                  disablePortal: true,
                }}
                arrow
                title={
                  <Typography
                    style={{
                      fontFamily: "Montserrat",
                      fontSize: "14px",
                      color: "#fff",
                      fontWeight: "bold",
                      padding: 0,
                      margin: 0,
                    }}
                  >
                    Click to Confirm Session
                  </Typography>
                }
              >
                <Button
                  onClick={() => handleEngagementConfirmation(null, null)}
                  variant="contained"
                  className={classes.confirmButtonOverview}
                >
                  confirm
                </Button>
                {/* <span
                className="tooltiptext tooltip-bottom"
                style={{ width: "180px", left: "510px" }}
              >
                Click to Confirm Session
              </span> */}
              </Tooltip>
            </Box>
          )}
      </Box>

      {/* <Box
        style={{ marginTop: 0 }}
        className={classes.mentorshipDocumentsContainer}
      >
        <Typography
          className={clsx(
            classes.mentorshipOverviewHeading,
            "homepageThirdHeader"
          )}
          style={{ position: "relative", paddingBottom: "60px" }}
        >
          Ongoing Engagement Stages
          {data?.mentorshipStatus !== undefined &&
            data?.mentorshipStatus !== "CLOSED" &&
            (getEngagementNotesData === undefined ||
              getEngagementNotesData === null) &&
            (getStartUpFeedBackData === undefined ||
              getStartUpFeedBackData === null) &&
            JSON.parse(localStorage.getItem("SavedLoggedInData"))?.role !==
              "Admin" && (
              <div
                className="dashboard-blue-btn top-btn newuserTooltip"
                style={{
                  width: "300px",
                  cursor: "pointer",
                  position: "absolute",
                  right: 0,
                  bottom: "-20px",
                  paddingTop: "15px",
                }}
                onClick={() => {
                  scheduleSessionCheck();
                }}
              >
                <div
                  className="blue-link-dashboard"
                  style={{
                    paddingRight: "0px",

                    fontWeight: "600",
                  }}
                >
                  {" "}
                  SCHEDULE SESSION
                </div>
                <span className="tooltiptext schedule  tooltip-bottom">
                  Schedule Session
                </span>
              </div>
            )}
        </Typography>
        <Stepper
          data={data?.mentorshipStatus}
          sessionNotesToggle={checkSessionStatus}
          completedMentorshipToggle={
            (getEngagementNotesData === undefined ||
              getEngagementNotesData === null) &&
            (getStartUpFeedBackData === undefined ||
              getStartUpFeedBackData === null)
              ? false
              : true
          }
        />
      </Box> */}

      {sessionList?.length > 0 && (
        <Box
          className={clsx(
            classes.sessionsSummary,
            classes.mentorshipDocumentsContainer
          )}
        >
          <Typography
            className={clsx(
              classes.mentorshipOverviewHeading,
              "homepageThirdHeader"
            )}
            style={{ position: "relative", paddingBottom: "40px" }}
          >
            Sessions Summary
            {data?.mentorshipStatus !== undefined &&
              data?.mentorshipStatus !== "CLOSED" &&
              (getEngagementNotesData === undefined ||
                getEngagementNotesData === null) &&
              (getStartUpFeedBackData === undefined ||
                getStartUpFeedBackData === null) &&
              JSON.parse(localStorage.getItem("SavedLoggedInData"))?.role !==
                "Admin" && (
                <Tooltip
                  classes={{
                    tooltip: classes.tooltip,
                    tooltipArrow: classes.tooltipArrow,
                  }}
                  PopperProps={{
                    disablePortal: true,
                  }}
                  arrow
                  title={
                    <Typography
                      style={{
                        fontFamily: "Montserrat",
                        fontSize: "14px",
                        color: "#fff",
                        fontWeight: "bold",
                        padding: 0,
                        margin: 0,
                      }}
                    >
                      Click to Schedule Session
                    </Typography>
                  }
                >
                  <div
                    className="dashboard-blue-btn top-btn"
                    style={{
                      width: "30%",
                      cursor: "default",
                      position: "absolute",
                      right: 0,
                      bottom: "-20px",
                      paddingTop: "7px",
                    }}
                    onClick={() => {
                      setModalOpen(true);
                      // scheduleSessionCheck();
                    }}
                  >
                    <a
                      className="blue-link-dashboard"
                      style={{
                        paddingRight: "0px",
                        cursor: "pointer",
                        fontWeight: "600",
                      }}
                    >
                      {" "}
                      SCHEDULE SESSION
                    </a>
                    {/* <span className="tooltiptext tooltip-bottom">
                    Schedule Session
                  </span> */}
                  </div>
                </Tooltip>
              )}
          </Typography>
          <Paper elevation={6} className={classes.sessionsSummarySurface}>
            <Grid
              container
              spacing={2}
              columnSpacing={1}
              className={classes.sessionsSummarySurfaceInner}
            >
              <Grid item xs={3}>
                <Typography
                  style={{ textAlign: "left" }}
                  className={classes.sessionsSummarySubheading}
                >
                  ENGAGEMENT TASK
                </Typography>
              </Grid>
              <Grid item xs={2}>
                <Typography className={classes.sessionsSummarySubheading}>
                  STATUS
                </Typography>
              </Grid>
              <Grid item xs={4}>
                {/* <Typography className={classes.sessionsSummarySubheading}>
                  SESSION INFO
                </Typography> */}
                <div className="sessionInfoHeading">SESSION INFO</div>
              </Grid>
              <Grid item xs={3}>
                <div className="sessionInfoHeading2">SESSION NOTES</div>
              </Grid>
              {sessionList?.map((session, index) => (
                <React.Fragment key={index}>
                  <Grid item xs={3}>
                    <Typography className={classes.summarySession}>
                      SESSION {index + 1}
                    </Typography>
                  </Grid>
                  <Grid item xs={2} className="newuserTooltip">
                    {session?.sessionStatus === "COMPLETED" ? (
                      <>
                        <SessionButton fullWidth disabled>
                          COMPLETED
                        </SessionButton>
                        <span className="tooltiptext completed tooltip-bottom">
                          Session Completed
                        </span>
                      </>
                    ) : valueoflogin?.role != "Admin" ? (
                      <ReactSelect
                        options={[
                          { value: "SCHEDULED", label: "SCHEDULED" },
                          { value: "COMPLETED", label: "COMPLETED" },
                        ]}
                        value={defaultValue}
                        ref={selectInputRef}
                        onChange={(e) => {
                          if (e.value === "COMPLETED") {
                            newfunctionTime(session)
                          }
                          // if (e.value === "COMPLETED") {

                          //   let sessionTime = moment(
                          //     session?.sessionStart
                          //   ).format("DD-MM-YYYY hh:mm A");
                          //   let completedTime =
                          //     session?.sessionDuration === 0.5
                          //       ? moment(sessionTime, "DD-MM-YYYY hh:mm A")
                          //           .add(30, "minutes")
                          //           .format("HH:mm")
                          //       : moment(sessionTime, "DD-MM-YYYY hh:mm A")
                          //           .add(session?.sessionDuration, "hours")
                          //           .format("HH:mm");
                          //   let completedDateTime =
                          //     session?.sessionDuration === 0.5
                          //       ? moment(sessionTime, "DD-MM-YYYY hh:mm A")
                          //           .add(30, "minutes")
                          //           .format("DD-MM-YYYY hh:mm A")
                          //       : moment(sessionTime, "DD-MM-YYYY hh:mm A")
                          //           .add(session?.sessionDuration, "hours")
                          //           .format("DD-MM-YYYY hh:mm A");
                          //   let currentDateTime =moment().format("DD-MM-YYYY hh:mm A")
                          //   if (
                          //     currentDateTime > completedDateTime
                          //   ) {
                          //     setSessionCompleted(session.scheduleId);
                          //     setTimeout(() => {
                          //       setModalVisibileParent(!modalVisibileParent);
                          //     }, 1000);
                          //   } else {
                          //     let sessionDate = moment(
                          //       session?.sessionDate
                          //     ).format("DD-MM-YYYY");
                          //     let presentDate = moment().format("DD-MM-YYYY");
                          //     let sessionTime = moment(
                          //       session?.sessionDate
                          //     ).format("h:mma");
                          //     let presentTime2 = moment(presentDate, "h:mma");
                          //     if (moment(sessionDate).isSame(presentDate)) {
                          //       if (presentTime2 > completedTime) {
                          //         setSessionCompleted(session.scheduleId);
                          //       } else {
                          //         swal(
                          //           "Complete Existing Session",
                          //           "You Cannot Complete Session Before Scheduled Meet Time",
                          //           "info"
                          //         );
                          //       }
                          //     } else {
                          //       swal(
                          //         "Complete Existing Session",
                          //         "You Cannot Complete Session Before Scheduled Meet Time",
                          //         "info"
                          //       );
                          //     }
                          //   }
                          // }
                        }}
                        defaultValue={{
                          label: session.sessionStatus,
                          value: session.sessionStatus,
                        }}
                        styles={customStyles}
                      />
                    ) : (
                      <SessionButton fullWidth disabled>
                        {session?.sessionStatus}
                      </SessionButton>
                    )}
                  </Grid>
                  <Grid item container spacing={2} xs={7}>
                    <Grid item xs={6} className="newuserTooltip">
                      <SessionButton
                        onClick={() => {
                          setSessionModalOpen(true);
                          setSessionModalData(session);
                        }}
                        fullWidth
                      >
                        {/* DETAILS */}
                        {session?.sessionStatus === "COMPLETED" ? (
                          "DETAILS"
                        ) : (
                          <>
                            <div className="d-flex">
                              <div>
                                {moment(session?.sessionStart).format(
                                  "DD-MM-YYYY"
                                )}
                              </div>
                              <div
                                style={{ position: "relative", left: "0.5rem" }}
                              >
                                {moment(session?.sessionStart).format(
                                  "hh:mm a "
                                )}
                                (
                                {moment
                                  .tz(
                                    props?.modalData?.sessionStart,
                                    Intl.DateTimeFormat().resolvedOptions()
                                      .timeZone
                                  )
                                  .format("z")
                                  .includes("-")
                                  ? "GMT" +
                                    moment
                                      .tz(
                                        props?.modalData?.sessionStart,
                                        Intl.DateTimeFormat().resolvedOptions()
                                          .timeZone
                                      )
                                      .format("z")
                                  : moment
                                      .tz(
                                        props?.modalData?.sessionStart,
                                        Intl.DateTimeFormat().resolvedOptions()
                                          .timeZone
                                      )
                                      .format("z")}
                                )
                              </div>
                            </div>
                          </>
                        )}
                      </SessionButton>
                      <span className="tooltiptext engagementNotes tooltip-bottom">
                        View Details
                      </span>
                    </Grid>
                    <Grid item xs={6} className="newuserTooltip">
                      {session?.momStartupSubmitted === true ? (
                        <>
                          <SessionButton
                            onClick={() => {
                              setSummaryModalOpen(true);
                              // setSummaryModalData(session);
                              setSummarySessionId(session.scheduleId);
                              getSummaryMom(session.scheduleId);
                            }}
                            fullWidth
                          >
                            SUMMARY
                          </SessionButton>
                          <span className="tooltiptext engagementNotes tooltip-bottom">
                            View Summary
                          </span>
                        </>
                      ) : (
                        <>
                          <SessionButton
                            onClick={() => {
                              if (
                                localStorage.getItem("SavedLoggedInData") &&
                                JSON.parse(
                                  localStorage.getItem("SavedLoggedInData")
                                )?.role !== "Admin"
                              ) {
                                if (session.sessionStatus === "SCHEDULED") {
                                  swal(
                                    "Session Incomplete",
                                    "Please Complete Session to Fill NOTES",
                                    "info"
                                  );
                                } else {
                                  setSessionMomModalOpen(true);
                                  setSummarySessionId(session.scheduleId);
                                }
                              }
                            }}
                            fullWidth
                          >
                            Fill NOTES
                          </SessionButton>
                          <span className="tooltiptext engagementNotes tooltip-bottom">
                            Fill Notes
                          </span>
                        </>
                      )}
                    </Grid>
                    {/* <Grid item xs={3}>
                    <SessionButton
                      fullWidth
                      onClick={() => setIsModalShown(true)}
                    >
                      DOCUMENT
                    </SessionButton>
                  </Grid> */}
                  </Grid>
                </React.Fragment>
              ))}

              <Grid item xs={12}>
                <Divider
                  style={{
                    backgroundColor: "#3ac2d7",
                    height: "3px",
                    marginTop: "20px",
                  }}
                />
              </Grid>
              <Grid item xs={12} className={classes.sessionsSummarySubheading2}>
                {data?.mentorshipStatus !== undefined &&
                data?.mentorshipStatus === "CLOSED"
                  ? "Your Engagement is Closed"
                  : "To Complete the Mentorship Engagement please give feedback and provide your remarks in Engagement Notes"}
              </Grid>
              {/* <Grid item xs={12} className={classes.sessionsSummarySubheading2}>
                To Complete the Mentorship Engagement please give feedback and
                provide your remarks in Engagement Notes
              </Grid> */}
              <Grid item xs={3}>
                <Typography className={classes.summarySession}>
                  ENGAGEMENT STATUS
                </Typography>
              </Grid>
              {data?.mentorshipStatus === "CLOSED" ? (
                <>
                  <Grid item xs={2} className="newuserTooltip">
                    <SessionButton fullWidth disabled>
                      COMPLETED
                    </SessionButton>
                    <span
                      className="tooltiptext  tooltip-bottom"
                      style={{ width: "189px", top: "52px", left: "54px" }}
                    >
                      Engagement Completed
                    </span>
                  </Grid>
                </>
              ) : (
                <>
                  <Grid item xs={2}>
                    <ReactSelect
                      options={[
                        { value: "ONGOING", label: "ONGOING" },
                        { value: "COMPLETED", label: "COMPLETE & CLOSE" },
                      ]}
                      isDisabled={
                        localStorage.getItem("SavedLoggedInData") &&
                        JSON.parse(localStorage.getItem("SavedLoggedInData"))
                          ?.role === "Admin"
                          ? true
                          : false
                      }
                      value={{
                        value: mentorshipStatus,
                        label: mentorshipStatus,
                      }}
                      onChange={(e) => {
                        if (
                          localStorage.getItem("SavedLoggedInData") &&
                          JSON.parse(localStorage.getItem("SavedLoggedInData"))
                            ?.role !== "Admin"
                        ) {
                          if (e.value === "COMPLETED") {
                            let check = sessionList?.find((ele) => {
                              if (ele.sessionStatus === "SCHEDULED")
                                return true;
                            });
                            if (check) {
                              swal(
                                "Please Complete Scheduled Sessions",
                                "Please Complete or Delete Scheduled Sessions",
                                "info"
                              );
                            } else if (checkFillNotesList === false) {
                              swal(
                                "Please Fill Session Notes",
                                "To Complete Engagement please fill Session Notes.",
                                "info"
                              );
                            } else if (
                              checkFillNotesList &&
                              !checkOppositeFillNotesList
                            ) {
                              swal(
                                !checkOppositeFillNotesList &&
                                  checkFillNotesList
                                  ? "Mentor's Session Note Not Submitted"
                                  : "Please Fill Session Notes",
                                !checkOppositeFillNotesList &&
                                  checkFillNotesList
                                  ? "Please wait till Mentor Completes their Session Notes"
                                  : "To Complete Engagement please fill Session Notes.",
                                "info"
                              );
                            } else if (
                              getStartUpFeedBackData === null ||
                              getStartUpFeedBackData === undefined
                            ) {
                              setMentorFeedbackModalOpen(true);
                            } else if (
                              getEngagementNotesData === undefined ||
                              getEngagementNotesData === null
                            ) {
                              setEngagementNotesModalOpen(true);
                            } else if (
                              (getStartUpFeedBackData !== undefined ||
                                getStartUpFeedBackData !== null) &&
                              (getEngagementNotesData !== undefined ||
                                getEngagementNotesData !== null)
                            ) {
                              setDidDataChange(didDataChange + 1);
                              setMentorshipStatus("COMPLETED");

                              let params = {
                                mentorId: getStartUpFeedBackData.mentorId,
                                startupId: getStartUpFeedBackData.startupId,
                                mentorshipId:
                                  getStartUpFeedBackData.mentorshipId,
                                overallRating:
                                  getStartUpFeedBackData.overallRating,
                                mentorBehaviour:
                                  getStartUpFeedBackData.mentorBehaviour,
                                adviceAndGuidance:
                                  getStartUpFeedBackData.adviceAndGuidance,
                                responsiveness:
                                  getStartUpFeedBackData.responsiveness,
                                mentorshipStatus: "CLOSED",
                              };
                              postStartUpFeedback(params);
                            }
                            // else if(getStartUpFeedBackData === null){
                            //   setMentorFeedbackModalOpen(true);
                            // }

                            //                           else {
                            //                             setMentorshipStatus("COMPLETED");

                            // }
                            // if (check || checkFillNotesList === false) {
                            //   swal(
                            //     "Please Complete Scheduled Sessions",
                            //     "Please Complete or Delete Scheduled Sessions",
                            //     "info"
                            //   );
                            // } else {
                            //   setMentorFeedbackModalOpen(true);
                            //   // setMentorshipStatus("COMPLETED");
                            // }
                          }
                        }
                      }}
                      styles={customStyles}
                    />
                  </Grid>
                </>
              )}
              {/* <Grid item xs={2}>
                {
                  getStartUpFeedBack && getStartUpFeedBack !== null ? (
                    <ReactSelect
                    options={[
                      { value: "COMPLETED", label: "COMPLETED" },
                    ]}
                    value={{ value: "COMPLETED", label: "COMPLETED" }}
                    onChange={(e) => {
                      if (e.value === "COMPLETED") {
                        let check = sessionList?.find((ele) => {
                          if (ele.sessionStatus === "SCHEDULED") return true;
                        });
                        if (check) {
                          swal(
                            "Please Complete Scheduled Sessions",
                            "Please Complete or Delete Scheduled Sessions",
                            "info"
                          );
                        } else {
                          setMentorFeedbackModalOpen(true);
                          // setMentorshipStatus("COMPLETED");
                        }
                      }
                    }}
                    styles={customStyles}
                    isDisabled
                  />
                  ) :(
                    <ReactSelect
                    options={[
                      { value: "ONGOING", label: "ONGOING" },
                      { value: "COMPLETED", label: "COMPLETED" },
                    ]}
                    value={{ value: mentorshipStatus, label: mentorshipStatus }}
                    onChange={(e) => {
                      if (e.value === "COMPLETED") {
                        let check = sessionList?.find((ele) => {
                          if (ele.sessionStatus === "SCHEDULED") return true;
                        });
                        if (check) {
                          swal(
                            "Please Complete Scheduled Sessions",
                            "Please Complete or Delete Scheduled Sessions",
                            "info"
                          );
                        } else {
                          setMentorFeedbackModalOpen(true);
                          // setMentorshipStatus("COMPLETED");
                        }
                      }
                    }}
                    styles={customStyles}
  
                  />
                  )
                }
              </Grid> */}

              <Grid item container spacing={2} xs={7}>
                <Grid item xs={6} className="newuserTooltip">
                  <SessionButton
                    fullWidth
                    onClick={() => {
                      if (
                        getStartUpFeedBackData !== undefined &&
                        getStartUpFeedBackData === null
                      )
                        completeEngagmentFn("feedback");
                      else setMentorFeedbackModalOpen(true);
                    }}
                  >
                    {getStartUpFeedBackData !== undefined &&
                    getStartUpFeedBackData === null
                      ? "GIVE FEEDBACK"
                      : "VIEW FEEDBACK"}
                  </SessionButton>
                  <span className="tooltiptext engagementNotes tooltip-bottom">
                    {getStartUpFeedBackData !== undefined &&
                    getStartUpFeedBackData === null
                      ? "Click to Give Feedback"
                      : "Click to View Feedback"}
                  </span>
                  {/* {data?.mentorshipStatus === "CLOSED" ? (
                    <>
                      <SessionButton
                        fullWidth
                        onClick={() => setMentorFeedbackModalOpen(true)}
                      >
                        VIEW FEEDBACK
                      </SessionButton>
                      <span className="tooltiptext engagementNotes tooltip-bottom">
                        Click to View Feedback
                      </span>
                    </>
                  ) : (
                    <>
                      <SessionButton
                        fullWidth
                        onClick={() => {
                          completeEngagmentFn();
                        }}
                      >
                        {getStartUpFeedBackData === undefined ||
                        getStartUpFeedBackData === null
                          ? "GIVE FEEDBACK"
                          : "VIEW FEEDBACK"}
                      </SessionButton>
                      {getStartUpFeedBackData === undefined ||
                      getStartUpFeedBackData === null ? (
                        <span className="tooltiptext engagementNotes tooltip-bottom">
                          Click to Give Feedback
                        </span>
                      ) : (
                        <span className="tooltiptext engagementNotes tooltip-bottom">
                          Click to View Feedback
                        </span>
                      )}
                    </>
                  )} */}
                </Grid>
                {/* <Grid item xs={6}>
                  <SessionButton
                    fullWidth
                    onClick={() => setMentorFeedbackModalOpen(true)}
                  >
                    GIVE FEEDBACK
                  </SessionButton>
                </Grid> */}
                <Grid item xs={6} className="newuserTooltip">
                  <SessionButton
                    fullWidth
                    onClick={() => {
                      if (
                        getEngagementNotesData !== undefined &&
                        getEngagementNotesData === null
                      )
                        setEngagementNotesModalOpen(true);
                      else completeEngagmentFn("notes");
                    }}
                    // onClick={() => setEngagementNotesModalOpen(true)}
                    // onClick={()=>{
                    //   let check = sessionList?.find((ele) => {
                    //     if (ele.sessionStatus === "SCHEDULED") return true;
                    //   });
                    //   if (check) {
                    //     swal(
                    //       "Please Complete Scheduled Sessions",
                    //       "Please Complete or Delete Scheduled Sessions",
                    //       "info"
                    //     );
                    //   }

                    //   else if(checkFillNotesList === false)
                    //   {
                    //     swal(
                    //       "Please Fill Session Notes",
                    //       "To Complete Engagement please fill Session Notes.",
                    //       "info"
                    //     );
                    //   }
                    //   else if(getEngagementNotesData !== undefined && getEngagementNotesData !== null ) {
                    //     setEngagementNotesDataModalOpen(true);
                    //
                    //   }
                    //   else{
                    //     setEngagementNotesModalOpen(true)
                    //   }
                    // }}
                  >
                    {getEngagementNotesData !== undefined &&
                    getEngagementNotesData !== null
                      ? "ENGAGEMENT NOTES DETAILS"
                      : "ENGAGEMENT NOTES"}
                  </SessionButton>
                  {getEngagementNotesData !== undefined &&
                  getEngagementNotesData !== null ? (
                    <span className="tooltiptext engagementNote tooltip-bottom">
                      View Engagement Notes
                    </span>
                  ) : (
                    <span className="tooltiptext engagementNote tooltip-bottom">
                      Type Engagement Notes
                    </span>
                  )}
                </Grid>
              </Grid>
            </Grid>
          </Paper>
        </Box>
      )}

      <Box className={classes.mentorshipDocumentsContainer}>
        <img
          src={sideGraphic}
          alt="side graphic 1"
          className={classes.sideGraphic2}
        />
        <Typography
          className={clsx(
            classes.mentorshipOverviewHeading,
            "homepageThirdHeader"
          )}
          style={{ position: "relative", paddingBottom: "40px" }}
        >
          Mentorship Documents
          {data?.mentorshipStatus !== undefined &&
          data?.mentorshipStatus === "CLOSED" &&
          localStorage.getItem("SavedLoggedInData") &&
          JSON.parse(localStorage.getItem("SavedLoggedInData"))?.role ==
            "Admin" ? (
            ""
          ) : uploadDocLimit >= 5 ? (
            <Grid item xs={12} className={classes.sessionsSummarySubheading3}>
              You have Exceeded Maximum Upload Limit of 5 Documents
            </Grid>
          ) : (
            <>
              {valueoflogin.role == "Admin" ? (
                ""
              ) : (
                <Grid
                  item
                  xs={12}
                  className={classes.sessionsSummarySubheading4}
                >
                  Upload upto 5 Documents
                </Grid>
              )}
              {uploadDocLimit == 5 || valueoflogin.role == "Admin" ? (
                ""
              ) : (
                <Tooltip
                  classes={{
                    tooltip: classes.tooltip,
                    tooltipArrow: classes.tooltipArrow,
                  }}
                  PopperProps={{
                    disablePortal: true,
                  }}
                  arrow
                  title={
                    <Typography
                      style={{
                        fontFamily: "Montserrat",
                        fontSize: "14px",
                        color: "#fff",
                        fontWeight: "bold",
                        padding: 0,
                        margin: 0,
                      }}
                    >
                      Click to Upload Document
                    </Typography>
                  }
                >
                  <div
                    className="dashboard-blue-btn top-btn"
                    style={{
                      width: "30%",
                      cursor: "default",
                      display: "flex",
                      alignItems: "initial",
                      position: "relative",
                      left: "38%",
                      // position: "absolute",
                      // right: 0,
                      // bottom: "-20px",
                      // paddingTop: "7px",
                      // top: "4.5rem",
                    }}
                    onClick={() => {
                      if (data?.mentorshipStatus === "CLOSED") {
                        swal(
                          "Engagement Closed",
                          "This Mentorship Engagement is complete",
                          "info"
                        );
                      }
                      setIsModalShown(true);
                    }}
                  >
                    <a
                      className="blue-link-dashboard"
                      style={{
                        paddingRight: "0px",
                        cursor: "pointer",
                        fontWeight: "600",
                        position:"sticky"
                      }}
                    >
                      {" "}
                      UPLOAD DOCUMENT
                    </a>
                    {/* <span className="tooltiptext schedule  tooltip-bottom">
                    Upload Document
                  </span> */}
                  </div>
                </Tooltip>
              )}
            </>
          )}
          {/* <Grid item xs={12} className={classes.sessionsSummarySubheading3}>
          Upload upto 5 Documents
              </Grid> */}
          {/* {
            data?.documents && data?.documents?.length  < 5 && ( */}
        </Typography>
        {data?.documents && data?.documents?.length > 0 ? (
          <MentorshipDocumentTable childData={data?.documents} />
        ) : (
          <MentorshipDocumentTable
            childData={"NoRecords"}
            mentorshipStatus={data?.mentorshipStatus}
            openDocModal={setIsModalShown}
          />
        )}
      </Box>

      {completedSessionList?.length > 0 && (
        <Box className={classes.completedSessionsContainer}>
          <Typography
            style={{ marginBottom: "30px" }}
            className={clsx(
              classes.mentorshipOverviewHeading,
              "homepageThirdHeader"
            )}
          >
            Completed Sessions: {completedSessionList?.length}
          </Typography>

          <Grid container spacing={3}>
            {completedSessionList?.map((ele, index) => (
              <Grid item xs={12} md={4}>
                {/* {
                  setBottleTableItem(sessionMomList.find(data => data.sessionId === ele.sessionId))
                } */}
                <CompletedSessionTable
                  setSummaryModalOpen={setSummaryModalOpen}
                  setSummaryModalData={setSummaryModalData}
                  setSessionModalData={setSessionModalData}
                  setSessionModalOpen={setSessionModalOpen}
                  sessionId={summarySessionId}
                  setSummarySessionId={setSummarySessionId}
                  setShowAllSummary={setShowAllSummary}
                  data={ele}
                  number={index + 1}
                  index={index}
                  sessionSummaryList={sessionMomList}
                  getSummaryMom={getSummaryMom}
                  bottleTableItem={sessionMomList.find(
                    (data) => data.sessionId === ele.scheduleId
                  )}
                  mentorshipId={params.mentorshipId}
                  modalDataList={sessionMomList}
                />
              </Grid>
            ))}
          </Grid>
        </Box>
      )}
      <Modal
        modalOpen={modalOpen}
        mentorshipId={params.mentorshipId}
        setModalOpen={setModalOpen}
        setDidDataChange={setDidDataChange}
        didDataChange={didDataChange}
        modalData={sessionModalData}
        openEditModal={setEditModalVisibility}
        EditModalValue={editModalVisibility}
        setParentVisibility={setSessionModalOpen}
        setSessionNotesCount={setCheckFillNotesList}
        setCheckSessionStatus={setCheckSessionStatus}
      />
      <SessionsModal
        modalVisibility={sessionModalOpen}
        setModalVisibility={setSessionModalOpen}
        modalData={sessionModalData}
        setModalOpen={setModalOpen}
        openEditModal={setEditModalVisibility}
        parentData={setSessionModalChild}
        fromModule="EngagmentPage"
      />

      {sessionMomList && sessionMomList?.length > 0 && (
        <SummaryModal
          modalVisibility={summaryModalOpen}
          setModalVisibility={setSummaryModalOpen}
          summaryData={summaryModalData}
          sessionId={summarySessionId}
          modalDataList={sessionMomList}
          parentData={setSessionMomChildData}
          setShowVideo={setShowVideo}
          // summaryData={getSummaryMomData}
        />
      )}
      {/* {sessionMomList && sessionMomList?.length > 0 && (
        <AllSummaryModal
          modalVisibility={showAllSummary}
          setModalVisibility={setShowAllSummary}
          summaryData={summaryModalData}
          sessionId={summarySessionId}
          modalDataList={sessionMomList}
          parentData={setSessionMomChildData}
          summaryFullModalData={summaryFullModalData}
          // summaryData={getSummaryMomData}
        />
      )} */}

      <SessionsMomModal
        modalVisibility={sessionMomModalOpen}
        setModalVisibility={setSessionMomModalOpen}
        modalData={sessionMomModalData}
        mentorshipId={params.mentorshipId}
        sessionId={summarySessionId}
        parentData={setSessionMomChildData}
        parentData2={setSessionMomChildData2}
      />
      <BasicModal open={showVideo} setOpen={setShowVideo} />
      <MentorFeedBackModal
        modalVisibility={mentorFeedbackModalOpen}
        setModalVisibility={setMentorFeedbackModalOpen}
        mentorshipId={params.mentorshipId}
        mentorId={data?.mentor?.id}
        parentData={setMentorFeedbackParent}
        feedBackData={getStartUpFeedBackData}
      />
      <EngagementNotesModal
        mentorshipId={params.mentorshipId}
        modalVisibility={engagementNotesModalOpen}
        setModalVisibility={setEngagementNotesModalOpen}
        engagementParentData={setEngagementParentData}
      />
      <EngagementNotesDataModal
        modalVisibility={engagementNotesDataModalOpen}
        setModalVisibility={setEngagementNotesDataModalOpen}
        engagementData={getEngagementNotesData}
      />
      <ModalDocUpload
        sendToParent={setUploadDocumentParent}
        modalVisibility={isModalShown}
        mentorshipId={params.mentorshipId}
        setModalVisibility={setIsModalShown}
      />
      <ChatBoxModal
        modalVisibility={chatBoxModalOpen}
        setModalVisibility={setChatBoxModalOpen}
        receiverInfo={data?.mentor}
        receiverId={data?.mentor?.id}
      />
      {/* {isModalShown && (
            <ModalDocUpload
              sendToParent={setUploadDocumentParent}
              modalVisibility={isModalShown}
              setModalVisibility={setIsModalShown}
              // fromModule="startUpDashboard"
            />
          )} */}
    </Box>
  );
};

// const mapDispatchToProps = (dispatch) => ({
//   openLoader: () => dispatch(isLoading(true)),
//   closeLoader: () => dispatch(isLoading(false)),
// });
const mapStateToProps = (state) => {
  return {
    getSummaryMomData: state.StartUpReducer.getSummaryData.data,
    getDocumentList: state.StartUpReducer.uploadDocumentList.data,
    getStartUpFeedBackData: state.StartUpReducer.getStartupFeedback.data,
    getEngagementNotesData: state.StartUpReducer.getEngagementNotes.data,
    getStepperData: state.AdminMentorReducer.getStepperList.list,
  };
};
export default connect(mapStateToProps, {
  openLoader,
  closeLoader,
  getStepperTooltipData,
  getSessionSummaryData,
  postSessionSummaryData,
  getUploadDocumentList,
  getStartUpFeedback,
  getEngagementNotes,
  postStartUpFeedback,
})(withRouter(MentorEngagementSummary));
// export default connect(null, ,mapDispatchToProps)(MentorEngagementSummary);
